import React, { useState } from 'react';
import { MonthNav, monthCells, useSwipe } from './AccessCalendar';
import { todayAdelaide, fmtDay } from './familyApi';

const WEEK = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

const peopleOn = (accounts, day) => accounts.filter((a) =>
  a.access.status !== 'terminated' && !a.access.paused && (a.mode === 'lifetime' || a.dates.includes(day)));

export const WhoHasAccessCalendar = ({ accounts }) => {
  const [cursor, setCursor] = useState(() => new Date());
  const [picked, setPicked] = useState(todayAdelaide());
  const today = todayAdelaide();
  const custom = accounts.filter((a) => a.mode === 'custom');
  const swipe = useSwipe(() => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1)),
    () => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1)));
  const onPicked = peopleOn(accounts, picked);

  return (
    <div data-testid="who-has-access-calendar" className="rounded-3xl border-2 border-sky-200 bg-sky-50/60 p-4 sm:p-6">
      <h3 className="text-lg font-bold text-sky-900 mb-1">Who has access when</h3>
      <p className="text-xs text-sky-800/70 mb-3">Numbers show how many custom-day people have access. Lifetime people have access every day.</p>
      <MonthNav cursor={cursor} setCursor={setCursor} testPrefix="who-calendar" />
      <div {...swipe} className="touch-pan-y max-w-md mx-auto">
        <div className="grid grid-cols-7 gap-1 mb-1">{WEEK.map((w, i) => <div key={i} className="text-center text-[11px] font-bold text-sky-800/70">{w}</div>)}</div>
        <div className="grid grid-cols-7 gap-1">
          {monthCells(cursor).map((day, i) => {
            if (!day) return <div key={`e${i}`} />;
            const n = custom.filter((a) => a.dates.includes(day) && a.access.status !== 'terminated').length;
            return (
              <button key={day} type="button" data-testid={`who-calendar-day-${day}`} onClick={() => setPicked(day)}
                className={`aspect-square rounded-lg text-xs font-semibold flex flex-col items-center justify-center transition-colors
                  ${n ? 'bg-sky-500 text-white' : 'bg-white text-slate-600 hover:bg-sky-100'} ${picked === day ? 'ring-4 ring-amber-400' : ''} ${day === today ? 'underline' : ''}`}>
                <span>{Number(day.slice(8))}</span>
                {n > 0 && <span className="text-[10px] leading-none">{n}</span>}
              </button>
            );
          })}
        </div>
      </div>
      <div data-testid="who-calendar-picked" className="mt-3 rounded-xl bg-white p-3 text-sm">
        <div className="font-bold text-sky-900 mb-1">{fmtDay(picked)}</div>
        {onPicked.length === 0 ? <span className="text-slate-500">Nobody has access.</span>
          : <div className="flex flex-wrap gap-1.5">{onPicked.map((a) => (
            <span key={a.user_id} className="rounded-full bg-sky-100 px-2 py-0.5 text-sky-900 text-xs font-semibold">{a.name}{a.mode === 'lifetime' ? ' ∞' : ''}</span>))}</div>}
      </div>
    </div>
  );
};
